import BaseBankLogo, { BaseBankLogoProps, BankLogoConfig } from './BaseBankLogo';

type BoaLogoProps = Omit<BaseBankLogoProps, 'config' | 'renderLogo'>;

const boaConfig: BankLogoConfig = {
    colors: {
        background: '#ffffff',
        border: '#E2E2E2',
        logo: '#E31837',
    },
    defaultAlt: 'Bank of America Logo',
};

const renderBoaLogo = (colors: { background: string; border?: string; logo: string }, clipPathId: string) => (
    <>
        <g clipPath={`url(#${clipPathId})`}>
            <path
                d="M31.9269 44.6798C39.5058 38.2689 50.1524 32.036 55.9991 29.7921C55.0968 29.2223 53.6893 28.4031 52.1013 27.5127C44.5585 29.9702 35.7524 35.4195 27.8848 41.5812C29.2201 42.5784 30.6276 43.6113 31.9269 44.6798Z"
                fill={colors.logo}
            />
            <path
                d="M28.4623 27.263C27.3435 26.7288 26.1164 26.2301 25.1781 25.8027C22.327 27.1918 18.6097 29.2931 13.918 32.6055C14.9285 33.1397 16.0112 33.7808 17.1661 34.4219C20.7751 31.7863 24.4202 29.2931 28.4623 27.263Z"
                fill="#012169"
            />
            <path
                d="M35.2116 24.2001C33.8401 23.4521 29.0762 21.7069 25.792 20.959C24.8176 21.3151 23.4462 21.8494 22.5078 22.2412C23.6988 22.5617 28.1379 23.7371 31.9274 25.6247C32.9018 25.1617 34.2732 24.5919 35.2116 24.2001Z"
                fill={colors.logo}
            />
            <path
                d="M19.0797 23.7373C14.8571 25.6606 10.418 28.2962 8 29.8277C8.86617 30.2195 9.73232 30.54 10.9233 31.1099C16.2647 27.5483 20.4511 25.3757 22.1113 24.6633C20.9203 24.2359 19.8015 23.951 19.0797 23.7373Z"
                fill="#012169"
            />
            <path
                d="M38.3882 23.0959C39.3626 22.7753 40.4814 22.4904 41.4558 22.2055C38.6408 21.0301 35.104 19.7836 31.928 19C31.4228 19.1425 29.907 19.5342 28.8604 19.8548C29.9431 20.1753 33.516 20.9945 38.3882 23.0959ZM20.5957 36.4877C21.7506 37.1644 22.9776 38.0904 24.1686 38.874C32.0724 32.8192 39.8679 28.1534 48.4213 25.5178C47.2303 24.9123 46.1837 24.3781 44.8483 23.737C39.7235 25.0192 30.9536 28.474 20.5957 36.4877Z"
                fill={colors.logo}
            />
        </g>
        <defs>
            <clipPath id={clipPathId}>
                <rect width="48" height="26" fill="white" transform="translate(8 19)" />
            </clipPath>
        </defs>
    </>
);

/**
 * Bank of America logo component with flexible sizing and color variants
 */
function BoaLogo(props: BoaLogoProps) {
    return <BaseBankLogo {...props} config={boaConfig} renderLogo={renderBoaLogo} />;
}

export default BoaLogo;
